import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import InputRadioButtons from 'components/input/InputRadioButtons';
import { useLocale } from '../../../components/special/LanguageProvider';
import { apiPostCall } from '../../../components/special/apiCall';
import { useToasts } from 'react-toast-notifications';

const BASE_URL = process.env.REACT_APP_ILWEB_API_URL;

const SettingRadioButton = ({ definition }) => {   
    const [settingValue, setSettingValue] = useState(JSON.parse(definition.value));
    const { t } = useLocale();
    const [oldValue, setOldValue] = useState(definition.value);        
    const { addToast } = useToasts();

    const updateSetting = (jsonValue) =>{
        apiPostCall(BASE_URL + '/admin/setting/save', {...definition, value : jsonValue}).then(res => {                      
            setOldValue(jsonValue)            
            if (res && res.error){
                addToast(res.error.message, { appearance: 'error', autoDismiss : false })
            }
            else{                
                addToast(t('Breyting fyrir "') + t(definition.name) +t('" vistuð.'), { appearance: 'success' , autoDismiss : true })
            }            
        });        
    }

    const [RadioButtonData, setRadioButtonData] = useState({
        radioButtonList: []
    });

    const loadRadioButtonData = async () => {
        setRadioButtonData({
        radioButtonList: [{
            itemID: 4,
            name: "4 (dæmi: 0123-XXXXXX)"
        },
        {
            itemID: 5,
            name: "5 (dæmi: 01234-XXXXXX)"
        }]})
    }

    useEffect(() => {
        loadRadioButtonData();
    }, []);

    const onUpdateValue = (value) => {
        let jsonValue = JSON.stringify(value);                
        setSettingValue(value);        
        if (jsonValue.localeCompare(oldValue) !== 0){            
            updateSetting(jsonValue);
        }
    }

    return (     
        <div className="table-wrap form">
        <table className="table">
            <colgroup>
                <col/>                
                <col />
            </colgroup>
        <thead>
        </thead>
        <tbody>                  
            <tr>
                <td className="no-border"><div className="form">{t(definition.name)}</div></td>                       
                <td className="no-border">  <InputRadioButtons name="AccruedCost" list={RadioButtonData.radioButtonList} keyField="itemID" displayField="name" defaultValue={settingValue} disabled={false} onChange={(value) => onUpdateValue(value)} /> </td>
            </tr>
        </tbody>
        </table>
        </div>          
        
        
      );
};


export default SettingRadioButton;
